
import { defineComponent } from "vue";
import Milestone from "./Milestone.vue";
import List from "./List.vue";

import MilestoneModel from "../model/Milestone";
export default defineComponent({
  name: "MilestoneList",
  components: { Milestone, List },
  props: {
    totalFunding: Number,
    milestones: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    getName: function (index: number, length: number): string {
      return MilestoneModel.getName(index, length);
    },
  },
});
